'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { mq, vw } from '@/styles'

import { SectionContact } from './SectionContact'

type Props = {
  about: boolean
}


export const WrapperAbout:FC<Props> = ({ about = false }) => {

  return (
    <Wrapper $about={about}>
      <SectionContact />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $about: Props['about'] }>` 
  margin-bottom: ${({ $about }) => $about ? vw(100, 'mobile') : '0' };
  margin-top:0;

  ${mq.greaterThan('tablet')}{
    margin-bottom: ${({ $about }) => $about ? vw(130, 'desktop') : '0' };
    margin-top:0;
  }
`